import { SiteCamerasResult } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { FOCUS_GRID_SIDE_PAGE_SIZE } from "./siteVideoWallConstants";

export interface SiteVideoWallAlertContext {
  detectionType: string;
  cameraName: string;
  formattedDate: string;
}

export const getFocusGridPageForCamera = (
  cameraId: string | null,
  cameras: SiteCamerasResult[],
  pageSize: number = FOCUS_GRID_SIDE_PAGE_SIZE
): number | null => {
  if (!cameraId) return 0;

  const index = cameras.findIndex((camera) => String(camera.id) === cameraId);
  if (index < 0) return null;

  return Math.floor(index / pageSize);
};

export interface SiteVideoWallPathParams {
  siteId: number | string;
  siteName?: string;
  cameraId?: string | null;
  alertContext?: Partial<SiteVideoWallAlertContext>;
}

/** Builds a shareable / open-in-new-tab path for the full site video wall. */
export const buildSiteVideoWallPath = ({
  siteId,
  siteName,
  cameraId,
  alertContext,
}: SiteVideoWallPathParams): string => {
  const params = new URLSearchParams();
  if (siteName) params.set("siteName", siteName);
  if (cameraId) params.set("cameraId", cameraId);
  if (alertContext?.detectionType) {
    params.set("detectionType", alertContext.detectionType);
  }
  if (alertContext?.cameraName) {
    params.set("cameraName", alertContext.cameraName);
  }
  if (alertContext?.formattedDate) {
    params.set("date", alertContext.formattedDate);
  }
  const query = params.toString();
  return `/sites/${siteId}/videowall${query ? `?${query}` : ""}`;
};
